var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","dir":""}},[_c('nav-Bar',{on:{"customChange":_vm.handleCustomChange}}),_c('router-view',{attrs:{"valSearch":this.search}}),_c('Page-Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }